module.exports = __webpack_public_path__ + "img/cup-2-stars.29eaf004.svg";